import OnsiteAverageDailyRateComponent from '../generic/OnsiteDailyAverageRate/OnsiteAverageDailyRate';
import { connectEditor } from './connect-editor';
import { getOnsiteAverageDailyRate } from './utils/onsite-average-daily-rate';

function mapStateToProps({ quote, quoteLinesById, productsById }) {
  return {
    average: getOnsiteAverageDailyRate(quote, quoteLinesById, productsById),
  };
}

const OnsiteAverageDailyRate = connectEditor(mapStateToProps)(
  OnsiteAverageDailyRateComponent,
);

export default OnsiteAverageDailyRate;
